//
import SlSaleDebitNoteModel from '@/models/Sale/SlSaleDebitNote'

/**
 * This class describes a sl customer.
 * @class SlSaleDebitNote (name)
 */
export default class SlSaleDebitNote extends SlSaleDebitNoteModel {

	/**
	 * Returns a list representation of the object.
	 * @return {Object} List representation of the object.
	 */
	static toCustomerDetail() {
		return class extends SlSaleDebitNoteModel {
			static includes = [
				'sl_customer',
				'sl_customer_branch_offices',
				//'sl_service_order.sl_sale_invoice_affected',
				//'sl_service_order.sl_sale_ticket_affected',
			]
		}
	}
}